import React, { useEffect, useState } from "react";
import DTOAboutMeModal from "./DTOAboutMeModal";
import AboutMeModalPresenter from "./AboutMeModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { aboutMeType } from "../../../interfaces/myProfile/personalDetails/aboutMeType";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { updateAboutMe } from "../../../../infra/aggregates/myProfile/aboutMeSlice";
import toast from "react-hot-toast";
import { setLoading } from "../../../../infra/aggregates/LoaderSlice";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  isCardUpdate: (data: boolean) => void;
  trans?: any;
}

const AboutMeModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const aboutMe_data = useAppSelector((state) => state.aboutMeSlice.about_me);
  const isLoading = useAppSelector((state) => state?.LoaderSlice.Loading);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const dispatch = useAppDispatch();

  const getData = (aboutMe: aboutMeType) => {
    updateAboutMeFunc(aboutMe);
  };

  async function updateAboutMeFunc(data: aboutMeType) {
    dispatch(setLoading(true));
    if (empId && data.about_me) {
      const payload = {
        emp_id: empId,
        about_me: data.about_me,
        locale: localStorage.getItem("emplang"),
      };
      await updatePersonalDetailsService
        .updateAboutMe(payload)
        .then((response: any) => {
          if (response.status == "success") {
            const about_me_data: any = {
              about_me: response.data,
              //locale: localStorage.getItem("emplang"),
            };
            dispatch(setLoading(false));
            dispatch(updateAboutMe(about_me_data));
            closeModal();
            toast.success(trans("Updated Successfully"));
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          toast.error(
            err?.response?.data?.message || err?.response?.data?.data
          );
        });
    } else {
      dispatch(setLoading(false));
      toast.error(trans("Invalid Data"));
      dispatch(setLoading(false));
    }
  }

  return (
    <div>
      <DTOAboutMeModal />

      <AboutMeModalPresenter
        callBackHandleClockIn={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        aboutMeDetail={aboutMe_data}
        isLoading={isLoading}
        trans={trans}
      />
    </div>
  );
};

export default AboutMeModalController;
